import type { MessagingMediumDetailView, MessagingMediumRowView } from "../api/gateway.js";
import { extendDisplayView, validatedDisplayView } from "./display-view.js";
import { portalLocale, portalResources, portalText, type PortalKey } from "./portal.js";

const keys = new Map<string, PortalKey<"messagingMedia">>(Object.entries(portalResources.en.messagingMedia).map(([key, value]) => [value, key as PortalKey<"messagingMedia">]));

/** Only known platform channel metadata is display copy. Addresses, credentials and customer names stay canonical. */
export function messagingMediumText(value: string): string {
  if (portalLocale() === "en") return value;
  const key = keys.get(value);
  return key === undefined ? value : portalText("messagingMedia", key);
}

export function localizeMessagingMediumRow<T extends MessagingMediumRowView>(row: T) {
  return validatedDisplayView(extendDisplayView(row, {
    get name() { return messagingMediumText(row.name); },
    get dek() { return messagingMediumText(row.dek); },
    get detail() { return messagingMediumText(row.detail); },
    get waitlistReason() { return row.waitlistReason === null ? null : messagingMediumText(row.waitlistReason); },
  }));
}

export function localizeMessagingMediumDetail(row: MessagingMediumDetailView): MessagingMediumDetailView {
  return validatedDisplayView(extendDisplayView(localizeMessagingMediumRow(row), {
    get blurb() { return messagingMediumText(row.blurb); },
    get step() { return row.step.map((step) => extendDisplayView(step, {
      get title() { return messagingMediumText(step.title); },
      get dek() { return messagingMediumText(step.dek); },
      get actionLabel() { return step.actionLabel === null ? null : messagingMediumText(step.actionLabel); },
    })); },
    get field() { return row.field.map((field) => extendDisplayView(field, {
      get label() { return messagingMediumText(field.label); },
      get placeholder() { return messagingMediumText(field.placeholder); },
    })); },
  }));
}
